import React from "react";

const Hdg = ({ section = "" }) => {
	return (
		<>
			<h1>The Valero Texas Open Is More Than Golf.</h1>
			<h3 style={{ marginTop: "0", marginBottom: "5px" }}>
				Help Us Tell the Story of the Valero Texas Open.
			</h3>
		</>
	);
};

export default Hdg;
